import { render, staticRenderFns } from "./changeHeadImg.vue?vue&type=template&id=ba47ee20&scoped=true"
import script from "./changeHeadImg.vue?vue&type=script&lang=js"
export * from "./changeHeadImg.vue?vue&type=script&lang=js"
import style0 from "./changeHeadImg.vue?vue&type=style&index=0&id=ba47ee20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba47ee20",
  null
  
)

export default component.exports